export default {
  data() {
    return {
      tracesConst: [
        {label: this.$t('trace.LOGIN'), value: 'LOGIN'},
        {label: this.$t('trace.CREATE_AUTONOMOUS_ACCESS'), value: 'CREATE_AUTONOMOUS_ACCESS'},
        {label: this.$t('trace.RESET_PASSWORD'), value: 'RESET_PASSWORD'},
        {label: this.$t('trace.ONBOARDING_CREATE'), value: 'ONBOARDING_CREATE'},
        {label: this.$t('trace.ONBOARDING_STEP1'), value: 'ONBOARDING_STEP1'},
        {label: this.$t('trace.ONBOARDING_STEP2'), value: 'ONBOARDING_STEP2'},
        {label: this.$t('trace.ONBOARDING_STEP3'), value: 'ONBOARDING_STEP3'},
        {label: this.$t('trace.ONBOARDING_STEP4'), value: 'ONBOARDING_STEP4'},
        {label: this.$t('trace.ONBOARDING_STEP5_INIT'), value: 'ONBOARDING_STEP5_INIT'},
        {label: this.$t('trace.ONBOARDING_STEP5'), value: 'ONBOARDING_STEP5'},
        {label: this.$t('trace.ONBOARDING_STEP6'), value: 'ONBOARDING_STEP6'},
        {
          label: this.$t('trace.ONBOARDING_DOCUMENT_RESUBMITTED'),
          value: 'ONBOARDING_DOCUMENT_RESUBMITTED',
        },
        {
          label: this.$t('trace.ONBOARDING_DOCUMENT_VALIDATED'),
          value: 'ONBOARDING_DOCUMENT_VALIDATED',
        },
        {label: this.$t('trace.ONBOARDING_DOCUMENT_REFUSED'), value: 'ONBOARDING_DOCUMENT_REFUSED'},
        {label: this.$t('trace.ONBOARDING_FINISHED'), value: 'ONBOARDING_FINISHED'},
        {label: this.$t('trace.ONBOARDING_SYNC'), value: 'ONBOARDING_SYNC'},
        {label: this.$t('trace.ANNUAL_REVENUE_OBJECTIVE'), value: 'ANNUAL_REVENUE_OBJECTIVE'},
      ],
    };
  },
  methods: {
    displayForTracesConst(value) {
      let result = this.tracesConst.find((el) => el.value === value);
      return result ? result.label : '';
    },
  },
  computed: {},
};
